import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  DefaultTitle, 
  DefaultSubtitle, 
  RadioButtonsContainer, 
  ApplicationMethodPDFReminderContainer ,
  ApplicationBodyContainer,
  ApplicationBodyContent,
  ApplicationBodyFooter
} from '../../../components/application/defaultComponents'
import ImgRadio from '../../../components/basic/ImgRadio'
import ReminderCard from '../../../components/basic/ReminderCard'
import Button from 'src/components/basic/Button'

import OnlineFormImg from '../../../assets/applicationFormsImgs/onlineform.svg'
import DownloadPdfImg from '../../../assets/applicationFormsImgs/downloadpdf.svg'

const RenewalType = () => {
  const navigate = useNavigate()
  const [renewalType, setRenewalType] = useState('')

  const nextRoute = renewalType === 'ONLINE' ? '/customer/renew/verify' : '/customer/renew/pdf'

  return (
    <ApplicationBodyContainer>
      <ApplicationBodyContent>
        <DefaultTitle>How would you like to complete your application?</DefaultTitle>
        <DefaultSubtitle>Please select an option below.</DefaultSubtitle>
        <RadioButtonsContainer>
          <ImgRadio 
            value="ONLINE" 
            onChange={e => setRenewalType(e.target.value)} 
            checked={renewalType === 'ONLINE'}
            label="Online"
          >
            <img src={OnlineFormImg} alt="online" />
          </ImgRadio>
          <ImgRadio 
            value="PDF" 
            onChange={e => setRenewalType(e.target.value)} 
            checked={renewalType === 'PDF'}
            label="Download PDF"
          >
            <img src={DownloadPdfImg} alt="pdf" />
          </ImgRadio>
        </RadioButtonsContainer>
        {renewalType === 'PDF' ? (
          <ApplicationMethodPDFReminderContainer>
            <ReminderCard
              icon='bulb'
              withLeftBar
              title='Downloading a PDF may take longer'
            >
              Our customers who use the online application typically fill out the form faster and more accurately.
            </ReminderCard>
          </ApplicationMethodPDFReminderContainer>
        ) : null}
      </ApplicationBodyContent>
      <ApplicationBodyFooter>
          <Button prebuilt='back' onClick={() => { navigate('/customer/renew/begin') }} />
          <Button prebuilt='next' disabled={!renewalType} onClick={() => { navigate(nextRoute) }} />
      </ApplicationBodyFooter>
    </ApplicationBodyContainer>
  )
}

export default RenewalType